module.exports = __webpack_public_path__ + "static/media/unbound6.4fe9b582.png";